import { Container, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function Profile () {

  return (
    <>
        <Helmet>
            <title> Profile | CaaS MS </title>
        </Helmet>
        <Container maxWidth="xl" >
            <Typography>User Profile</Typography>
        </Container>
    </>
  )
}
